import { requestMethod } from '../../common-scripts/request'
import logger from '../../common-scripts/logger'
import loginSuccMethods from '../../common-scripts/ursLoginSuccMethod'

//三方登录公共方法
function thirdLoginMethods(
  thirdUrl: string,
  methods: string,
  url: string,
): void {
  const thirdWindow = window.open(thirdUrl) as Window
  let timer = 0
  function checkChild(): void {
    if (thirdWindow.closed) {
      clearInterval(timer)
      requestMethod(url, methods)
        .then((data) => {
          loginSuccMethods(data)
        })
        .catch((err) => {
          logger.log(err)
          logger.log('失败')
        })
    }
  }
  timer = setInterval(checkChild, 250)
}

function qqLogin(): void {
  const url = '/login-qq.s'
  const methods = 'POST'
  const thirdUrl = 'https://ai.youdao.com/login-qq-authorize.s'
  thirdLoginMethods(thirdUrl, methods, url)
}

function weiboLogin(): void {
  const url = '/login-weibo.s'
  const methods = 'POST'
  const thirdUrl = 'https://ai.youdao.com/login-weibo-authorize.s'
  thirdLoginMethods(thirdUrl, methods, url)
}

function wxLogin(): void {
  const url = '/login-wx.s'
  const methods = 'POST'
  const thirdUrl = 'https://ai.youdao.com/login-wx-authorize.s'
  thirdLoginMethods(thirdUrl, methods, url)
}

$(function() {
  const $loginWay = $('.logo-content')
  const $haveQuestion = $('.have-question')
  $loginWay.on('click', function() {
    const selWay = $(this)[0].dataset.id
    if (selWay == 'weibo') {
      weiboLogin()
    } else if (selWay == 'qq') {
      qqLogin()
    } else {
      wxLogin()
    }
  })

  $haveQuestion.click(function() {
    window.open('https://m.reg.163.com/')
  })
})
